var cov_17goklooqq = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tabs/index.tsx",
      hash = "9d485087079a4f8e67b3b910e7115e894c21a976",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tabs/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 18
        }
      },
      "1": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 16
        }
      },
      "2": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 8,
          column: 33
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Tabs from './Tabs';
import Panel from './Panel';
import Link from './Link';
cov_17goklooqq.s[0]++;
Tabs.Panel = Panel;
cov_17goklooqq.s[1]++;
Tabs.Link = Link;
cov_17goklooqq.s[2]++;
Tabs.displayName = 'ShineoutTabs';
export default Tabs;